import { Injectable } from '@angular/core';
import { ReactiveProvider } from '../reactive-provider';
import { IWaitingList } from 'src/app/models/waiting-list.model'

@Injectable()
export class WaitingListService extends ReactiveProvider<IWaitingList> {
  protected url = "events/waiting-list";
}